import IndeterminateLoading from 'components/atoms/IndeterminateLoading'
import React from 'react'

import { StyledUnderlineText } from './styles'

const UnderlineText: React.FC<{ loading?: boolean }> = ({ children, loading }) => {
  return (
    <StyledUnderlineText>
      <div className="underline-text-content">
        {children}
        {loading && (
          <div className="underline-loading">
            <IndeterminateLoading />
          </div>
        )}
      </div>
    </StyledUnderlineText>
  )
}

export default UnderlineText
